"use strict";
import { parsePath } from "./legacy_history";
import queryString from "query-string";
export default function locationDescriptor(path, query = null, state = null) {
  const { pathname, search, hash } = parsePath(path);
  const queryParams = query ? queryString.stringify(query).replace(/%20/g, "+") : "";
  return {
    pathname,
    search: queryParams ? `${search}${search ? "&" : "?"}${queryParams}` : search,
    hash,
    state
  };
}
